import React, { Fragment } from "react";

import { Helmet } from "react-helmet-async";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link } from "react-router-dom";
import breadcrumbsItems from "../../../utils/breadcrumbsItems";
import { useTranslation } from "react-i18next";

const Breadcrumb = (props) => {
  const { type, breadcrumbItems, id, pageType = "", extraTitle } = props || {};
  const { t } = useTranslation();

  const title = t(`breadcrumb.${type}`);
  const titleType = `${type}${pageType}`;
  const titleHelmet = t(`breadcrumb.${titleType}`);

  const content = breadcrumbsItems(breadcrumbItems);

  return (
    <Fragment>
      <Helmet title={`LG | ${titleHelmet}`} />
      <div className="breadcrumb breadcrumb-main page-title-box d-sm-flex align-items-center justify-content-between">
        <div className="breadcrumb-title d-flex align-items-center justify-content-between">
          {type != "dashboard" && (
            <KeyboardBackspaceOutlinedIcon
              className="mr-2 cursor-pointer-back-icon"
              onClick={() => window.history.back()}
            />
          )}
          <div className="page-title-breadcrumb">
            {titleHelmet}
            {extraTitle && <span> "{extraTitle}"</span>}
          </div>
        </div>
        <div className="breadcrumb-button"></div>
        <div className="breadcrumb-path">
          <div className="page-title-right">
            <ol className="breadcrumb m-0">{content}</ol>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Breadcrumb;
